import initialState from 'store/globalState/initialState';

import {
  CREATE_ORGANIZATION_INIT,
  CREATE_ORGANIZATION_SUCCESS,
  CREATE_ORGANIZATION_FAILURE,
  EDIT_ORGANIZATION_INIT,
  EDIT_ORGANIZATION_SUCCESS,
  EDIT_ORGANIZATION_FAILURE,
  DELETE_ORGANIZATION_INIT,
  DELETE_ORGANIZATION_SUCCESS,
  DELETE_ORGANIZATION_FAILURE,
} from './types';

export function organizationReducer(state = initialState.session, action = {}) {
  switch (action.type) {
    case CREATE_ORGANIZATION_INIT:
    case EDIT_ORGANIZATION_INIT:
    case DELETE_ORGANIZATION_INIT:
      return {
        ...state,
        error: '',
      };
    case CREATE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        error: '',
        user: {
          ...state.user,
          organizations: [...state.user.organizations, action.payload],
        },
      };
    case EDIT_ORGANIZATION_SUCCESS:
      return {
        ...state,
        error: '',
        user: {
          ...state.user,
          organizations: state.user.organizations.map(org => (org.id === action.payload.id ? action.payload : org)),
        },
      };
    case DELETE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        error: '',
        user: {
          ...state.user,
          organizations: state.user.organizations.filter(org => org.id !== action.payload),
        },
      };
    case CREATE_ORGANIZATION_FAILURE:
    case EDIT_ORGANIZATION_FAILURE:
    case DELETE_ORGANIZATION_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
}
